module.exports = __webpack_public_path__ + "img/1.ccd4e2f0.png";